import {inject, IReactComponent} from 'mobx-react';
import {ChangeNumber} from './component';

import './styles.scss';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.inviteStore?.inviteFlowManager?.changeNumberController,
    translate: stores.inviteStore?.localizationService?.translate?.bind(stores.inviteStore.localizationService)
});

const ChangeNumberComponent = inject(mapStoresToProps)(ChangeNumber) as IReactComponent;

export default ChangeNumberComponent;
